// Both the Mini-Profile's open-refetch effect and its save success need this
// same household/resident refresh -- pulled out once so the two can't
// silently drift out of sync with each other (the save also invalidates the
// certification queries). The Certification tab's Special Needs save uses it
// too, so the Mini-Profile never opens on a stale record.
// queryClient is passed in, not read from the module-level import, so this
// is directly unit-testable with a mock.
const invalidateOccupantInfoQueries = (
  queryClient,
  { organizationId, propertyId, residentId },
) =>
  Promise.all([
    queryClient.invalidateQueries([
      'getResidentHousehold',
      organizationId,
      propertyId,
      residentId,
    ]),
    queryClient.invalidateQueries([
      'getResident',
      organizationId,
      propertyId,
      residentId,
    ]),
    // The can-* flags derive from the current email, so an edit leaves them stale until this
    // refetches. Keyed on customerId, hence the prefix.
    queryClient.invalidateQueries([
      'getPortalUserStatus',
      organizationId,
      propertyId,
    ]),
  ]);

export default invalidateOccupantInfoQueries;
